import { createFileRoute } from '@tanstack/react-router'
import SlideEditor from '~/client/components/slide-editor/components/SlideEditor'

export const Route = createFileRoute('/_app/slide-editor')({
  component: SlideEditorPage,
})

function SlideEditorPage() {
  return <SlideEditor />
}
